export default {
  Subs: {
    For: "Жазылым",
    PTM:
      "Дәрігерлерге арналған платформа «" +
      process.env.VUE_APP_INSTALL_NAME +
      "»",
    BySub: "Жазылым арқылы",
    Free: "Тегін",
    CostDesc: "<period> ішінде бір қолданушыға",
    month: "ай",
    day: "күн",
    year: "жыл",
    Connect: "Қосу",
    Connectv2: "Жазылымды қосу",
    CorpPlan: {
      desc: "Жеке",
      feature_1: "Жеке бағдарламалар",
      feature_2:
        "Айына таңдалған зерттеулер санын кез келген ЖИ көмегімен өңдеу",
      cost: "Сұраныс бойынша",
      request: "Өтінім қалдыру",
      requested: "Сіздің өтініміңіз сәтті жіберілді!",
      requested2:
        "Біз жақын арада сізбен байланысып, барлық мәліметтерді талқылаймыз және қолайлы шешім ұсынамыз. Сұрақтарыңыз болса, <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>бізге жазыңыз!</a>",
    },
    yourSub: "Сіздің жазылымыңыз",
    PlansDesc: "Тарифтер туралы толық ақпарат",
    Offer: "Келісімшарт",
    EnterPromo: "Промокодты енгізіңіз",
    Errors: {
      NotPurchase: "Жазылымды қосу мүмкін болмады, кейінірек қайталап көріңіз",
    },
    DiffSubs: "Тарифтер арасындағы айырмашылықтар",
    Plan: "Тариф",
    Unavailable: "Алдымен жазылымнан бас тарту қажет",
    extSub: "Кеңейтілгенді таңдау",
    lets: {
      modalTitle: {
        base: "Сіздің",
        and: " және ",
        phone: " телефон нөміріңізді",
        email: "электрондық поштаңызды",
      },
      text: "Жазылымды рәсімдеу үшін сіздің <PHONE><EMAIL> енгізуіңіз қажет. Бұл жазылым мәртебесі, операцияларды растау және басқа маңызды хабарламаларды жіберуге мүмкіндік береді",
      formInvalid: "Форма дұрыс толтырылмаған",
    },
    cancelSub: "Бас тарту",
    unsub: {
      title: "Сізге енді қолжетімді болмайды:",
      modalTitle: "Жазылымнан бас тартқыңыз келетініне сенімдісіз бе?",
      modalTitle2: "Бас тарту себебін таңдаңыз",
      cancel: "Жазылым <NAME> қалпына келтірілді. Келесі төлем <DATE>",
      yes: "Жазылымнан бас тарту",
      no: "Жазылымды сақтау",
      thx: {
        title: "Бізбен бірге қалғаныңыз үшін рақмет!",
        continue: "Жұмысты жалғастыру",
      },
      reasons: {
        0: "Бағасы ұнамайды",
        1: "Қызметті пайдаланбаймын",
        2: "Интерфейс ыңғайсыз",
        3: "Басқа",
      },
      complete: {
        title: "Сіз жазылымнан бас тарттыңыз",
        text1: "Сіздің жазылымыңыз келесі мерзімге дейін белсенді болады ",
        text2:
          ", осы уақытқа дейін жазылымды пайдалануды жалғастыра аласыз. Біз сізді қайта көруге қуаныштымыз!",
        recover: "Жазылымды қайта қосу",
      },
    },
    backToSite: "Сайтқа оралу",
    afterPay: {
      title: "Сіздің жазылымыңыз сәтті іске қосылды!",
      text: "Енді сізде қызметтің кеңейтілген функцияларына қол жеткізу бар!",
      buttonText: "Жұмысты бастау",
    },
  },
};
